export default __webpack_public_path__ + "static/media/the-momentum.1efd9ee1.png";